export default __webpack_public_path__ + "img/titan2.0.414d41.svg";